import { get } from 'lodash';
import { Website } from './legos/websiteTypes';

export const getWebsiteDealerContext = (website: Website) => {
  if (website.Dealer) {
    // Use website dealer if it is available as context for BYO/baseUrl
    return website.Dealer;
  }
  // If no dealer, use the group context from this website. Website must have one of these
  return get(website, 'DealerGroup.config');
};
